class Share {
  constructor() {
    this._init();
  }

  private _init() {
    const shareButton = document.getElementById(
      'share'
    ) as HTMLButtonElement | null;

    if (shareButton) {
      shareButton.addEventListener('click', async () => {
        const shareData: ShareData = {
          title: document.title, // Le titre de votre page
          //    text: "Jetez un oeil à ça !", // Un court texte
          url: window.location.href.split('?')[0] // Le lien de la page actuelle
        };

        if ('share' in navigator) {
          try {
            await navigator.share(shareData);
          } catch (err) {
            if (err instanceof Error && err.name !== 'AbortError') {
              console.error('Erreur lors du partage : ', err);
            }
          }
        } else {
          alert("Le partage natif n'est pas supporté sur ce navigateur.");
        }
      });
    }
  }
}

export const share = new Share();
